import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: newPassword });
      toast.success(data.message);
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <ShieldCheck className="w-7 h-7 text-petroleum" strokeWidth={1.5} />
          <span className="font-heading text-xl font-bold text-charcoal">CERH</span>
        </Link>
        <div className="bg-card border border-petroleum/10 rounded-2xl p-8 shadow-[0_8px_30px_rgba(14,79,79,0.08)]">
          <h1 className="font-heading text-2xl font-bold text-charcoal mb-4">Nueva contraseña</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label>Nueva contraseña</Label>
              <Input data-testid="reset-password-new-input" type="password" required minLength={8} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
            </div>
            <Button data-testid="reset-password-submit-button" type="submit" disabled={loading} className="w-full bg-petroleum rounded-full h-11">
              {loading ? "Guardando..." : "Restablecer contraseña"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
